import { Box, Stack, useTheme } from "@mui/material";
import { EmptyState } from "@chr/eds-react";
import { useTranslation } from "@chr/online-shared-ui-localizations";
import { Illustration } from "@chr/eds-react/EmptyState/EmptyStateProps";

export interface EmptyContentProps {
  title: string;
  bodyText?: string;
  hideBorder?: boolean;
  illustration?: Illustration;
}

export const EmptyContent = ({ title, bodyText, hideBorder, illustration }: EmptyContentProps) => {
  const theme = useTheme();
  const translate = useTranslation();

  return <Stack
    border={hideBorder ? '' : `1px solid ${theme.palette.divider}`}
    borderRadius="2px"
    width="100%"
    justifyContent="center"
    alignItems={'center'}
    paddingTop={illustration === 'none' ? 0 : 6}
    paddingBottom={illustration === 'none' ? 4 : 6}
    data-testid="empty-state"
  >
    <Box maxWidth="450px">
      <EmptyState
        title={title}
        illustration={illustration ?? 'box'}
        bodyText={
          bodyText ?? translate('At the moment this information is not available. Check again later for updates.')
        }
      />
    </Box>
  </Stack>
}
